import type { CustomerType } from '@/store/types/user'

// Overload: when toLowerCase is true, return string
export function mapCustomerType(
  customerType: CustomerType,
  options: { toLowerCase: true },
): string

// Overload: when toLowerCase is false/undefined, return CustomerType
export function mapCustomerType(
  customerType: CustomerType,
  options?: { toLowerCase?: false },
): CustomerType

// Implementation
export function mapCustomerType(
  customerType: CustomerType,
  options?: { toLowerCase?: boolean },
) {
  let mappedType: CustomerType

  switch (customerType) {
    case 'Family': {
      mappedType = 'Employee'
      break
    }
    case 'WholesaleCustomer':
    case 'PreferredCustomer': {
      mappedType = 'Associate'
      break
    }
    default: {
      mappedType = customerType
      break
    }
  }

  return options?.toLowerCase ? mappedType.toLowerCase() : mappedType
}
